import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { COMPANY_TYPES } from '../../../constants/companyTypes';

const CompanyTypeSelector = ({
  value = '',
  onChange,
  label = 'Company Type',
  required = false,
  disabled = false,
  fullWidth = true,
  size = 'medium',
  ...props
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      size={size}
      {...props}
    >
      <InputLabel id="company-type-selector-label">{label}</InputLabel>
      <Select
        labelId="company-type-selector-label"
        value={value}
        onChange={handleChange}
        label={label}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        <MenuItem value={COMPANY_TYPES.INTERNAL}>{COMPANY_TYPES.INTERNAL}</MenuItem>
        <MenuItem value={COMPANY_TYPES.PARTNER}>{COMPANY_TYPES.PARTNER}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default CompanyTypeSelector;
